import styled from "@emotion/styled";
import { Box, ListItemButton, Drawer as MuiDrawer } from "@mui/material";
import { t } from "i18next";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import useCompanyLogoQuery from "../../hooks/graphql-hooks/queries/useCompanyLogoQuery";
import { SidebarItemsType } from "../../models/sidebar";
import LoadingCircle from "../loadingCircle/LoadingCircle";
import SidebarNav from "./SidebarNav";

const asysIcon = require("../../assets/images/Arvato_Systems_Logo.png");

const Drawer = styled(MuiDrawer)`
  border-right: 0;

  > div {
    border-right: 0;
  }
`;

const Brand = styled(ListItemButton)<{
  component?: React.ReactNode;
  to?: string;
}>`
  font-size: ${(props) => props.theme.typography.h5.fontSize};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  color: ${(props) => props.theme.sidebar.header.color};
  background-color: ${(props) => props.theme.sidebar.header.background};
  font-family: ${(props) => props.theme.typography.fontFamily};
  min-height: 56px;
  padding-left: ${(props) => props.theme.spacing(6)};
  padding-right: ${(props) => props.theme.spacing(6)};
  justify-content: center;
  cursor: pointer;
  flex-grow: 0;

  ${(props) => props.theme.breakpoints.up("sm")} {
    min-height: 64px;
  }

  &:hover {
    background-color: ${(props) => props.theme.sidebar.header.background};
  }
`;

const BrandIcon = styled.img`
  margin-top: 12px;
  margin-bottom: 14px;
  height: 32px;
  border-right: "1px solid white";
`;

export type SidebarProps = {
  PaperProps: {
    style: {
      width: number;
    };
  };
  variant?: "permanent" | "persistent" | "temporary";
  open?: boolean;
  onClose?: () => void;
  items: {
    title: string;
    pages: SidebarItemsType[];
  }[];
  showFooter?: boolean;
  authorized: boolean;
};

const Sidebar: React.FC<SidebarProps> = ({
  items,
  showFooter = true,
  authorized,
  ...rest
}) => {
  const [companyLogo, setCompanyLogo] = useState("");

  const { loading } = useCompanyLogoQuery({
    skip: !authorized,
    dataAction: (url) => {
      setCompanyLogo(url);
    },
    errorAction: () => {
      setCompanyLogo(asysIcon);
    },
  });

  return (
    <Drawer variant="permanent" {...rest}>
      <Brand component={NavLink as any} to="/home">
        {!loading ? (
          <BrandIcon src={companyLogo} />
        ) : (
          <LoadingCircle className="mr-10" size={24} />
        )}
        <Box
          ml={1}
          style={{
            borderLeft: "2px solid white",
            padding: "5px 8px",
            height: "32px",
          }}
        >
          {t("suppliers")}
        </Box>
      </Brand>
      <SidebarNav items={items} />
    </Drawer>
  );
};

export default Sidebar;
